
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { GreenplumLinkedService } from 'app/model/linkedservice/greenplum.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.greenplum.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Greenplum_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Greenplum_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: GreenplumLinkedService.MODEL // Linked service redefined
        }
    }
})
export class GreenplumTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
